const invoiceStatus = {
  Openstaand: 1,
  Herinnering: 2,
  Aanmaning: 3,
  Sommatie: 4,
  Betalingsregeling: 5,
  Incassobureau: 6,
  Schuldhulptraject: 7,
  Faillissement: 8,
  Betaald: 9,
  AutomatischeIncasso: 10,
};

export default invoiceStatus;
